<template>
  <el-checkbox v-model="localValue" @change="handleChange"></el-checkbox>
</template>
<script>
import {actionTypes as articlesActionTypes} from '@/store/modules/articles'

export default {
  props: {
    id: {
      required: true
    },
    value: {
      required: true
    },
  },
  data(){
    return {
      localValue: false
    }
  },
  mounted() {
    this.localValue = this.value
  },
  methods: {
    handleChange(val){
      this.$store
          .dispatch(articlesActionTypes.setShow, {id: this.id, show: val})
          .then(() => this.$message('Изменения сохранены!'))
    }
  },
  watch: {
    value(val){
      this.localValue = val
    }
  }
}
</script>